import { browser } from '#BASE/common/util/util.browser';
import { storage } from 'BASE/common/util/util.storage';
import { urlCombine } from 'BASE/common/util/util.apiProxy';

export default {
    name: 'Logo',
    props: {
        storageKey: { type: String, default: '' },
        className1: { type: String, default: '' },
        className2: { type: String, default: '' },
    },
    data: function () {
        return {
            Logo: {
                FilePath: '',
            },
            StorageKey: this.storageKey,
            FaviconKey: storage.keys.KEY_FAVICON,
            LogoKeys: [
                storage.keys.LOGO_HOME_PAGE,
                storage.keys.LOGO_SPEEDTEST_PAGE,
                storage.keys.LOGO_REGISTER_PAGE,
                storage.keys.LOGO_LOGIN_PAGE,
                storage.keys.DEFAULT_PLAYER_IMAGEHEAD,
                storage.keys.KEY_FAVICON,
            ],
            IsMobile: browser.isMobile,
        };
    },
    methods: {
        async postJSON(url, data, success) {
            return $.ajax({
                url: url,
                type: 'POST',
                data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                async: true,
                success: success,
            });
        },

        async initLogo() {
            await this.getAllLogo();
            await this.initFavicon();
        },
        async getAllLogo() {
            let logo = storage.temp.get(this.StorageKey);
            if (!logo) {
                let logos = {};
                logos = await this.postJSON('/api/Logo/GetAllLogo');
                for (let key of this.LogoKeys) {
                    if (key == this.FaviconKey) {
                        storage.temp.set(key, logos[key]);
                    } else {
                        let filePath =
                            this.IsMobile && logos[key].MobileLogo
                                ? logos[key].MobileLogo.FilePath
                                : logos[key].PCLogo.FilePath;
                        storage.temp.set(key, filePath == null ? '' : filePath);
                    }
                }
                if (logos[this.StorageKey]) {
                    logo = storage.temp.get(this.StorageKey);
                }
            }
            this.Logo.FilePath = urlCombine(logo);
        },
        // 创建 favicon link 元素的共用函数
        createFaviconLink(filePath) {
            const link = document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = urlCombine(filePath);
            return link;
        },
        async initFavicon() {
            const faviconData = storage.temp.get(this.FaviconKey);
            if (faviconData) {
                const head = document.getElementsByTagName('head')[0];

                // 清除现有的 favicon
                const existingLinks = document.querySelectorAll("link[rel*='shortcut icon']");
                existingLinks.forEach((link) => {
                    link.remove();
                });

                // 使用 window.matchMedia 判斷是否為深色模式
                const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

                // 根據模式選擇對應的 favicon
                let faviconPath = null;
                if (isDarkMode && faviconData.MobileLogo && faviconData.MobileLogo.FilePath) {
                    faviconPath = faviconData.MobileLogo.FilePath;
                } else if (faviconData.PCLogo && faviconData.PCLogo.FilePath) {
                    faviconPath = faviconData.PCLogo.FilePath;
                }

                // 只創建一個 favicon
                if (faviconPath) {
                    const faviconLink = this.createFaviconLink(faviconPath);
                    head.appendChild(faviconLink);
                }
            }
        },
    },
    created() {
        this.initLogo();
    },
};
